import React from 'react'

const SuspenseLoader = () => {
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '100%',
				height: '100%',
			}}
		>
			<span className="load-component"></span>
		</div>
	)
}

export default SuspenseLoader
